<template>
    <nav class="nav">
        <a href="/"><img src="images/pufina-logo.png" alt="Logo" class="nav__logo"></a>

        <div class="nav__menu">
            <a href="#header" title="Home">Home</a>
            <a href="#campanie" title="Despre Campanie">Campanie</a>
            <!-- <a href="#premii" title="Premii">Premii</a> -->
            <a href="#articles" title="Articole">Articole</a>
            <a href="/docs/Regulament-Campanie-Distractie-in-Familie-cu-Pufina_autentificat.pdf" title="Regulament" target="_blank" rel="noopener noreferrer">Regulament</a>
            <!-- <a href="#inscriere" title="Inscriere">Inscriere</a> -->
        </div>
        
        <div class="hamburger">
            <div class="hamburger__line l1"></div>
            <div class="hamburger__line l2"></div>
            <div class="hamburger__line l3"></div>
        </div>
    </nav>
</template>

<script>
    export default {

    }
</script>